// 使用的图标

import Steam from '@/pages/home/assets/svg/dataSource/theme-icon/steam-theme.svg';
import Xbox from '@/pages/home/assets/svg/dataSource/theme-icon/xbox-theme.svg';
import Playstation from '@/pages/home/assets/svg/dataSource/theme-icon/playstation-theme.svg';
import Epic from '@/pages/home/assets/svg/dataSource/theme-icon/epic-theme.svg';
import Nintendo from '@/pages/home/assets/svg/dataSource/theme-icon/nintendo-theme.svg';
import Heybox from '@/pages/home/assets/svg/dataSource/theme-icon/heybox-theme.svg';
import Poe2 from '@/pages/home/assets/svg/dataSource/theme-icon/poe2-theme.svg';
import Kakao from '@/pages/home/assets/svg/dataSource/theme-icon/kakao-theme.svg';
import Default from '@/pages/home/assets/svg/dashboard/default.svg';
import DltbOfficialWebsite from '@/pages/home/assets/svg/dataSource/theme-icon/dltb-official-website.svg';
// 禁用图标
import SteamDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/steam.svg';
import XboxDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/xbox.svg';
import PlaystationDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/playstation.svg';
import EpicDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/epic.svg';
import NintendoDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/nintendo.svg';
import DefaultDisable from '@/pages/home/assets/svg/dataSource/socialmedia.svg';
import HeyboxDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/heybox.svg';
import Poe2Disable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/poe2.svg';
import KakaoDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/kakao.svg';
import DltbOfficialWebsiteDisable from '@/pages/home/assets/svg/dataSource/theme-icon/disableIcon/dltb-official-website-disable.svg';

// platform数据
export const platforms = [
  {
    icon: Steam,
    disableIcon: SteamDisable,
    title: 'Steam',
    color: '#326282',
  },
  {
    icon: Steam,
    disableIcon: SteamDisable,
    title: 'Steam(非Mac)',
    color: '#326282',
  },
  {
    icon: Steam,
    disableIcon: SteamDisable,
    title: 'SteamMac',
    color: '#326282',
  },
  {
    icon: Xbox,
    disableIcon: XboxDisable,
    title: 'Xbox',
    color: '#4DAB7D',
  },
  {
    icon: Playstation,
    disableIcon: PlaystationDisable,
    title: 'Playstation',
    subtitle: ['playstation','ps'],
    color: '#587EDB',
  },
  {
    icon: Epic,
    disableIcon: EpicDisable,
    title: 'Epic',
    subtitle: ['epics','epic'],
    color: '#FFC600',
  },
  {
    icon: Nintendo,
    disableIcon: NintendoDisable,
    title: 'Nintendo',
    color: '#F17C86',
  },
  {
    icon: Heybox,
    disableIcon: HeyboxDisable,
    title: 'HeyBox',
    color: '#6E7794',
    isBlack: true,
  },
  {
    icon: Nintendo,
    disableIcon: NintendoDisable,
    title: 'Switch',
    color: '#F17C86',
  },
  {
    icon: Default,
    disableIcon: DefaultDisable,
    title: 'scarlett',
    color: '#B5EFFF',
    isBlack: true,
    isOpacity: true
  },
  {
    icon: Default,
    disableIcon: DefaultDisable,
    title: 'pc launcher',
    color: '#307DA6',
    isBlack: true,
    isOpacity: true
  },
  {
    icon: Poe2,
    disableIcon: Poe2Disable,
    title: 'poe2_Official Website',
    color: '#B70B25',
  },
  {
    icon: Poe2,
    disableIcon: Poe2Disable,
    title: 'poe2_官网(Mac)',
    color: '#B70B25',
  },
  {
    icon: Poe2,
    disableIcon: Poe2Disable,
    title: 'poe2_官网(非Mac)',
    color: '#B70B25',
  },
  {
    icon: Poe2,
    disableIcon: Poe2Disable,
    title: 'poe2_Official Website(Mac)',
    color: '#B70B25',
  },
  {
    icon: Kakao,
    disableIcon: KakaoDisable,
    title: 'Kakao',
    color: '#FFE76E',
  },
  {
    icon: DltbOfficialWebsite,
    disableIcon: DltbOfficialWebsiteDisable,
    title: 'dl_the_beast_official website',
    color: '#B70B25',
  },

];

export const defaultPlatforms = {
  icon: Default,
  disableIcon: DefaultDisable,
  title: 'Default',
  color: '#5EC8F1',
};